import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../config/ApiConfig';
import DefaultModal from './DefaultModal';
import ConfirmModal from './ConfirmModal';
import useDefaultModal from '../hooks/useDefaultModal';
import useConfirmModal from '../hooks/useConfirmModal';


function PreEmpenhoModal({ show, preEmpenho, onClose, onSave }) {
  const [formData, setFormData] = useState({
    numPreEmpenho: '',
    numPreEmpenhoManual: '',
    ano: '',
    idFornecedor: '',
    tipoVinculo: '',
    idVinculo: '',
    idVinculo2: '',
    objeto: '',
    objetoEditado: '',
    dataEmissao: '',
    dataPrevisao: '',
    valorTotal: 0,
    status: 'PENDENTE',
    observacao: '',
  });
  const [validated, setValidated] = useState(false);
  const [loading, setLoading] = useState(false);
  const { setConfirmModal, showConfirmModal } = useConfirmModal();
  const isEditing = !!preEmpenho?.id;
  const token = localStorage.getItem('token');
  const ano = localStorage.getItem('anoBase');
  const vinculo = JSON.parse(localStorage.getItem('vinculo'));
  const user = JSON.parse(localStorage.getItem('user'));
  const { setDefaultModal, showDefaultModal } = useDefaultModal();

  useEffect(() => {
    if (show) {
      setDefaultModal.onClose();
      const formatDate = date => {
        if (!date) return '';
        if (Array.isArray(date)) {
          const [year, month, day] = date;
          return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
        }
        if (typeof date === 'string') return date.split('T')[0];
        return '';
      };

      if (preEmpenho) {
        setFormData({
          numPreEmpenho: preEmpenho.numPreEmpenho || '',
          numPreEmpenhoManual: preEmpenho.numPreEmpenhoManual || preEmpenho.numPreEmpenho || '',
          ano: ano,
          idFornecedor: preEmpenho.idFornecedor || '',
          tipoVinculo: preEmpenho.tipoVinculo || '',
          idVinculo: preEmpenho.idVinculo || '',
          idVinculo2: preEmpenho.idVinculo2 || '',
          objeto: preEmpenho.objeto || '',
          objetoEditado: preEmpenho.objetoEditado || preEmpenho.objeto || '',
          dataEmissao: formatDate(preEmpenho.dataEmissao),
          dataPrevisao: formatDate(preEmpenho.dataPrevisao),
          valorTotal: preEmpenho.valorTotal || 0,
          status: preEmpenho.status || 'PENDENTE',
          observacao: preEmpenho.observacao || '',
        });
      } else {
        setFormData({
          numPreEmpenho: '',
          numPreEmpenhoManual: '',
          ano: ano,
          idFornecedor: '',
          tipoVinculo: '',
          idVinculo: '',
          idVinculo2: '',
          objeto: '',
          objetoEditado: '',
          dataEmissao: new Date().toISOString().split('T')[0],
          dataPrevisao: '',
          valorTotal: 0,
          status: 'PENDENTE',
          observacao: '',
        });
      }
      setValidated(false);
    }
  }, [show, preEmpenho, token]);

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const anoInt = parseInt(ano, 10);
    if (!formData.numPreEmpenho || isNaN(anoInt)) {
      setValidated(true);
      return;
    }
    setLoading(true);
    const payload = {
      ...formData,
      numPreEmpenhoManual: formData.numPreEmpenhoManual || null,
      objetoEditado: formData.objetoEditado || null,
      ano: anoInt,
      idEntidade: vinculo.idEntidade,
      usuario: user?.login || '',
      valorTotal: parseFloat(formData.valorTotal) || 0,
      idVinculo: formData.idVinculo ? parseInt(formData.idVinculo) : null,
      idVinculo2: formData.idVinculo2 ? parseInt(formData.idVinculo2) : null,
    };
    if (preEmpenho?.id) payload.id = preEmpenho.id;

    try {
      if (preEmpenho?.id) {
        await axios.put(`${API_BASE_URL.PRE_EMPENHO}/${preEmpenho.id}`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (onSave) onSave();
        if (onClose) onClose();
        showDefaultModal('success', 'Pré-Empenho atualizado com sucesso!');
      } else {
        await axios.post(API_BASE_URL.PRE_EMPENHO, payload, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (onSave) onSave();
        if (onClose) onClose();
        showDefaultModal('success', 'Pré-Empenho cadastrado com sucesso!');
      }
    } catch (error) {
      console.error('Erro ao salvar Pré-Empenho:', error);
      showDefaultModal('error', 'Erro ao salvar Pré-Empenho. Verifique os dados e tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  if (!show) return null;

  return (
    <>
      <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div
              className="modal-header text-white"
              style={{
                background: 'linear-gradient(45deg, rgb(7, 29, 65) 0%, rgba(29, 100, 216, 1) 100%)',
                padding: '0.5rem 1rem',
                borderTopLeftRadius: '0.5rem',
                borderTopRightRadius: '0.5rem',
                border: 'none',
              }}
            >
              <h6 className="modal-title mb-0">
                <i className="bi bi-file-earmark-text me-2"></i>
                {preEmpenho ? 'Editar Pré-Empenho' : 'Novo Pré-Empenho'}
              </h6>
              <button type="button" className="btn-close btn-close-white" onClick={onClose} disabled={loading} title="Fechar"></button>
            </div>
            <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
              <form onSubmit={handleSubmit} noValidate>
                <div className="row">
                  <div className="col-md-4">
                    <div className="mb-3">
                      <div className="d-flex justify-content-between align-items-center mb-1">
                        <label className="form-label small fw-semibold mb-0">
                          Nº Pré-Empenho Manual
                        </label>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-secondary py-0"
                          onClick={() => showConfirmModal('restore', () => setFormData(prev => ({ ...prev, numPreEmpenhoManual: prev.numPreEmpenho })))}
                          title="Restaurar valor original"
                        >
                          <i className="bi bi-arrow-counterclockwise"></i>
                        </button>
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        name="numPreEmpenhoManual"
                        value={formData.numPreEmpenhoManual}
                        onChange={handleChange}
                        maxLength={20}
                        placeholder="Ex: PE0001/2024"
                        disabled={loading}
                      />
                      <small className="text-muted">Se preenchido, este número será usado na impressão.</small>
                    </div>
                  </div>
                </div>

                <div className="mb-3">
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <label className="form-label small fw-semibold mb-0">Objeto Editado</label>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-secondary py-0"
                      onClick={() => showConfirmModal('restore', () => setFormData(prev => ({ ...prev, objetoEditado: prev.objeto })))}
                      title="Restaurar valor original"
                    >
                      <i className="bi bi-arrow-counterclockwise"></i>
                    </button>
                  </div>
                  <textarea
                    className="form-control"
                    rows={2}
                    name="objetoEditado"
                    value={formData.objetoEditado}
                    onChange={handleChange}
                    placeholder="Edite o objeto do Pré-Empenho..."
                    disabled={loading}
                  />
                  <small className="text-muted">Se preenchido, este texto será usado na impressão.</small>
                </div>

              </form>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary btn-sm" onClick={onClose} disabled={loading}>
                <i className="bi bi-x-circle me-1"></i>Cancelar
              </button>
              <button type="submit" className="btn btn-primary btn-sm" onClick={handleSubmit} disabled={loading}>
                {loading ? (
                  <><span className="spinner-border spinner-border-sm me-1"></span>Salvando...</>
                ) : (
                  <><i className="bi bi-check-circle me-1"></i>Salvar</>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
      <DefaultModal {...setDefaultModal} />
      <ConfirmModal {...setConfirmModal} />
    </>
  );
}

export default PreEmpenhoModal;
